import React, { Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import { checkPermissions } from "capitalrx-utilities";

import { DashboardListItems } from "./DashboardListItems";
import DashboardItem, { DashboardItemProps } from "./DashboardItem";
import { usePermissions } from "capitalrx-shell";

const DashboardContent: React.FC = () => {
  const [actions] = usePermissions();
  const transitionDelay = 0.1;
  const transitionTimeout = 2000;
  const transitionProps = {
    component: Fragment,
    transitionName: "slide-up",
    transitionAppear: true,
    transitionAppearTimeout: transitionTimeout,
    transitionEnter: false,
    transitionLeave: false,
  };

  const dashboardListItemProps = (value: DashboardItemProps, i: number): DashboardItemProps => {
    return {
      url: value.url,
      sectionImage: value.sectionImage,
      title: value.title,
      classes: value.classes,
      description: value.description,
      transitionDelay: `${i * transitionDelay}s`,
    };
  };

  return (
    <div className="dashboard-content-wrapper">
      <div className="dashboard-content-top row">
        <ReactCSSTransitionGroup {...transitionProps}>
          {DashboardListItems.map((value, i) => {
            const allowed = checkPermissions(actions, value.requiredPermissions);
            if (value.mainSection && allowed) return <DashboardItem key={value.url} {...dashboardListItemProps(value, i)} />;
          })}
        </ReactCSSTransitionGroup>
      </div>
      <div className="dashboard-content-bottom row">
        <ReactCSSTransitionGroup {...transitionProps}>
          {DashboardListItems.map((value, i) => {
            const allowed = checkPermissions(actions, value.requiredPermissions);
            if (!value.mainSection && allowed) return <DashboardItem key={value.url} {...dashboardListItemProps(value, i)} />;
          })}
        </ReactCSSTransitionGroup>
      </div>
    </div>
  );
};

export default DashboardContent;
